export const optionsUntrustDevice = {
  title: 'Untrust Device',
  body: 'Are you sure you want to untrust this device?',
  buttonText: 'Untrust',
  buttonClassName: 'btn btn-danger'
};



// WEBPACK FOOTER //
// ./src/utils/alerts.js